import { call, put, takeLatest } from "redux-saga/effects";
import {
  deleteFacultyStart,
  deleteFacultySuccess,
  deleteFacultyFailure,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { httpDeleteFaculty } from "../../../services/faculty";
import { successNotifier } from "../../../utils/helpers";

export function* deleteFaculty({ payload }) {
  const { id, callback } = payload;
  const response = yield call(httpDeleteFaculty, id);
  const { success, raw, message } = response;

  if (success) {
    yield put(deleteFacultySuccess());
    successNotifier("faculty deleted successfully");
    if (callback) {
      callback();
    }
  } else {
    yield put(deleteFacultyFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onDeleteFaculty() {
  yield takeLatest(deleteFacultyStart.type, deleteFaculty);
}
